import { useCallback, useMemo } from 'react'
import { generateAllForQuery } from 'utils/helpers'
import { useDeletePatientFilesMutation } from 'services'

export const useFileDelete = type => {
    const [deleteFiles, result] = useDeletePatientFilesMutation()

    const handleDelete = useCallback(
        data => {
            const payload = generateAllForQuery({ type, ...data })
            deleteFiles({ id: data.id, query: payload })
        },
        [deleteFiles]
    )

    return useMemo(
        () => ({
            deleteFiles: handleDelete,
            result,
        }),
        [handleDelete]
    )
}
